import { useState, useCallback, useRef } from 'react';

export function useToggle(initialValue: boolean) {
    const [value, setValue] = useState(initialValue);
    const toggle = useCallback(() => setValue((prev) => !prev), []);
    const setOn = useCallback(() => setValue(true), []);
    const setOff = useCallback(() => setValue(false), []);
    return [value, { toggle, setOn, setOff }] as const;
}
